import { instance } from './ApiService';
import { AlertType, AlertClaim, RawAlertClaim, PaginatedData } from '../types';
import { Omit } from 'react-router';
const urljoin = require('url-join');

const ALERT_CLAIMS_PATH = '/alert_claims';

function alertPath(id: AlertClaim['id']): string {
    return urljoin(ALERT_CLAIMS_PATH, id.toString());
}

async function getClaims(alertType: AlertType[]): Promise<AlertClaim[]> {
    let results = await Promise.all(alertType.map((type => (instance.get<PaginatedData<RawAlertClaim>>(ALERT_CLAIMS_PATH, { params: { type } })) )));
    return results.map(result => result.data.results.map(AlertClaim.fromRaw)).reduce((a, b) => a.concat(b), []);
}

async function getClaim(id: AlertClaim['id']): Promise<AlertClaim> {
    return AlertClaim.fromRaw((await instance.get<RawAlertClaim>(alertPath(id))).data);
}

async function patchClaim(id: AlertClaim['id'], changes: Partial<Omit<AlertClaim, 'id'>>): Promise<AlertClaim> {
    return AlertClaim.fromRaw((
        await instance.patch<RawAlertClaim>(
            alertPath(id),
            changes))
        .data);
}

async function deleteClaim(id: AlertClaim['id']): Promise<void> {
    await instance.delete(alertPath(id));
}

export {
    getClaims as getAlertClaims,
    getClaim as getAlertClaim,
    patchClaim as updateAlertClaim,
    deleteClaim as deleteAlertClaim,
    ALERT_CLAIMS_PATH,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/AlertClaimService.ts